<template>
  <div class="entertainment-card-main">
    <div class="entertainment-card" v-for="(packItem,index) in listData" :key="index">
      <div class="circle-dot-title-box not-shorex">{{packItem.name}}</div>
      <div v-for="(item ,i) in packItem.children" :key="i" class="entertainment-card__content">
        <div class="flex-between-box" :class="{'not-margin': item.couponUserId}">
          <div class="bd-left">
            <van-image
            width="1.9rem"
            class="list-image"
            fit="cover"
            :src="item.mobileBanner"
            @click="goDetail(item)"
            />
            <!-- <img class="union-pay-ico" src="../../assets/union_pay_ico.png" alt=""> -->
            <div class="label" v-show="item.promotionImage">
              <img class="label-img" :src="item.promotionImage" />
            </div>
          </div>
          <div class="bd-right">
            <div class="list-title">{{item.name}}</div>
            <div class="sell-out">
              <sell-out-tip v-if="item.showLowStock == true" :showLowStock="item.showLowStock" :outOfStock="item.outOfStock"/>
            </div>
            <div :class="['price-discount-box', GlobalData.discountTypeStyle[item.discountType]]">
              <div v-if="item.discountType" class="discount-type">{{GlobalData.discountTypeValue[item.discountType]}}</div>
              <div class="discount-price">{{item.priceDiscounted}}</div>
              <div class="discount-unit">{{(item.PriceByRouteDays||item.priceByRouteNights)? '美元/航次' : item.priceUnit}}</div>
              <div class="discount-number">x{{item.qty}}</div>
            </div>
            <div class="price-original-box" v-show="item.price > item.priceDiscounted">
              <span>{{item.price}}</span>
              <span>{{(item.PriceByRouteDays||item.priceByRouteNights)? '美元/航次' : item.priceUnit}}</span>
            </div>
            <div class="price-total-box">
              <div class="price-total-box__left">
                <div class="total-type">总额</div>
                <div class="total-price">{{item.total}}</div>
              </div>
              <div class="total-unit">美元</div>
              <price-desc-bar></price-desc-bar>
            </div>
            <div class="entertainment-item" v-if="item.packageItems.length > 0">
              <div class="flex-center-box" v-for="(packageitem, key) in item.packageItems" :key="key">
                <div class="blue-color el">{{packageitem.name}}</div>
                <div class="item-time el">{{packageitem.shipDate}}  {{packageitem.timeSlotStartTime}}-{{packageitem.timeSlotEndTime}}</div>
              </div>
            </div>
            <div  v-if="item.shipDate!=='1753-01-01'" class="list-time blue-color" >{{item.shipDate}}
              <template v-if="item.timeSlotStartTime">{{item.timeSlotStartTime}}-{{item.timeSlotEndTime}}</template>
            </div>
            <div class="list-tips blue-color" v-if="item.priceByRouteNights || item.priceByRouteDays">全程</div>
            <div class="order-detail">
              <div class="detail-list" v-for="(guest,i) in item.bookingGuestAndStateroomNumbers" :key="i">
                <div><span>船票订单号:{{guest.bookingId}}</span> <span>房间号:{{guest.stateroomNumber}}</span></div>
                <div>
                  <span v-for="(persons,personIndex) in guest.bookingGuest.guestPersons" :key="personIndex">{{persons.pyLastName}}/{{persons.pyFirstName}}{{guest.bookingGuest.guestPersons.length === personIndex + 1 ? '' : ','}}</span>
                </div>
              </div>
            </div>
            <template v-if="item.productGifts && item.productGifts.length">
              <div v-for="(gift,giftIdx) in item.productGifts"
                   :key="giftIdx">
                <div class="product-gift-box not-margin">
                  <div class="icon">
                    <img src="../../assets/icons/iconGift.png" alt="" />
                  </div>
                  <div class="name">{{gift.productGiftName}}</div>
                </div>
                <div v-if="gift.productGiftShipDate && gift.productGiftShipDate !== '1753-01-01'" class="product-gift-time-box" :class="{'is-android': isAndroid}">
                  <span>礼品预订时间段：</span>{{gift.productGiftShipDate}} {{gift.productGiftTimeslotStart}} - {{gift.productGiftTimeslotEnd}}
                </div>
                <div class="product-gift-desc-box">
                  *&nbsp;部分赠送的产品对乘客参与或使用有一定的限制条件（如年龄、身高、身体状况等）；不符合条件的乘客将无法参与预订赠礼活动或无法使用所赠产品，预订前请务必仔细阅读相关产品详情页面。
                </div>
              </div>
            </template>
            <div class="card-btn" v-if="isShow && !item.cmsBookOnly">
              <div class="edit-button">
                <van-button class="item-btn" @click="showDialogBooking(item)">编辑</van-button>
                <van-button class="item-btn btn-linear-gradient" @click="deleteBtn(item.id)">删除</van-button>
                <!-- 编辑弹框 -->
                <dialog-booking :visible.sync="editShow" :goodsInfo="currentProduct" @submitSuccess="submitSuccess"/>
              </div>
            </div>
          </div>
        </div>
        <coupon-select-popup v-if="item.couponUserId"
                             view-type="PREVIEW"
                             :user-coupon="{
                               couponUserId: item.couponUserId,
                               couponTitle: item.couponTitle,
                               couponTotalDiscountAmount: item.couponTotalDiscountAmount
                             }"/>
      </div>
    </div>
  </div>
</template>

<script>
import DialogBooking from '@/views/DialogBooking'
import { Dialog } from 'vant'
import { showAlert, isAndroid } from '@/utils/tools'
import api from '@/api'
import pick from 'lodash/pick'
import { gioTracking } from '@/plugins/common'

import SellOutTip from '@/components/SellOutTip.vue'

import PriceDescBar from "@/components/coupon/PriceDescBar.vue";
import CouponSelectPopup from "@/components/coupon/CouponSelectPopup.vue";
// import uniq from 'lodash/uniq'

export default {
  name: 'EntertainmentCard',

  components: {
    DialogBooking,
    SellOutTip,
    CouponSelectPopup,
    PriceDescBar,
  },

  data () {
    return {
      editShow: false,
      currentProduct: {},
      listData: []
    }
  },

  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    cardData: {
      type: Array,
      default: function () {
        return []
      }
    },
    allBookingGuests: Array
  },
  watch: {
    cardData: {
      handler (val) {
        this.listData = val
      },
      deep: true
    }
  },
  created () {
    this.listData = this.cardData
    this.isAndroid = isAndroid;
  },
  // computed: {
  //   cardDataFormat () {
  //     return this.cardData.map(x => {
  //       const productIds = uniq(x.packageItems.map(j => j.productId))
  //       return {
  //         ...x,
  //         packageItems: productIds.map(j => (x.packageItems.find(y => y.productId === j)))
  //       }
  //     })
  //   }
  // },

  methods: {
    priceFormat (current) {
      return current % 1 === 0 ? current : current.toFixed(2)
    },
    showDialogBooking ({ productId, bookingGuestAndStateroomNumbers, shoppingCartIds, ...current }) {
      this.currentProduct = {
        ...pick(current, ['name', 'mobileBanner', 'applyTo', 'needSync', 'qty', 'shipDate', 'timeSlot', 'packageItems', 'categoryName']),
        id: productId,
        shoppingCartIds: shoppingCartIds,
        initBookingGuests: bookingGuestAndStateroomNumbers.map(({ ...others }) => ({
          ...others,
          bookingGuests: this.allBookingGuests.filter(j => j.bookingRecord_Id === others.bookingRecordId).map(x => ({ ...x, canSelect: true }))
        })),
        initBookingGuestsChoosed: [].concat.apply([], bookingGuestAndStateroomNumbers.map(x => x.bookingGuest.guestPersons.map(j => j.id))),
        productGift: current.productGifts && current.productGifts.length ? current.productGifts[0] : null
      }
      this.editShow = true
    },
    deleteBtn (val) {
      Dialog.confirm({
        message: '确定要删除该产品？'
      }).then(() => {
        // on confirm
        this.deleteProduct(val)
      }).catch(() => {
        // on cancel
      })
    },
    async deleteProduct (val) {
      const { errCode, errMsg } = await api.deleteProduct({ shoppingCartIds: [val] })
      if (errCode === 0) {
        this.$emit('deleteRefreh')
      } else {
        showAlert(errMsg)
      }
    },
    submitSuccess () {
      this.$emit('deleteRefreh')
    },
    goDetail (val) {
      gioTracking('track','evt_prdClick', {'productID': val.productId,'Product_Category': val.categoryName, 'Product_DetailProduct': val.name })
      this.$router.push(`/Rccl.PCP/product/detail/${val.productId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.entertainment-card{
  font-size: 20px;
  & + .entertainment-card {
    border-top: 1px solid @cart-card-border;
  }
  .entertainment-card__content {
    padding: 22px 20px 0;
    & + .entertainment-card__content{
      padding: 30px 20px 0;
      border-top: 1px solid @cart-card-border;
    }
  }
  .flex-between-box {
    margin-bottom: 30px;
    &.not-margin {
      margin-bottom: 0;
    }
  }
  .item-top-tag{
    font-size: 26px;
    color: @main-gray3;
    padding: 5px 20px;
    background-color: #f0f0f0;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 46px;
    padding-bottom: 0px;
  }
  .list-image{
    display: block;
    margin-bottom: 10px;
  }
  .bd-left{
    width: 190px;
    .union-pay-ico{
      width: 140px;
      height: 30px;
      display: block;
      padding: 0;
      margin: 0;
    }
  }
  .bd-right{
    flex: 1;
    padding-left: 30px;
    .list-title{
      font-size: 26px;
      color: @main-color;
      margin-bottom: 5px;
      margin-top: -5px;
    }
    .list-price{
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 10px;
      .number{
        display: inline-block;
        margin-left: 10px;
      }
      .price-left{
        font-size: 20px;
      }
      .price-right{
        .price-color{
          font-size: 30px;
        }
      }
    }
    .entertainment-item{
      margin-bottom: 28px;
      font-size: 20px;
      .blue-color{
        padding-right: 10px;
        flex: 1;
      }
    }
    .list-time{
      margin-top: 14px;
      line-height: 28px;
    }
    .list-tips{
      margin-top: 14px;
      line-height: 28px;
    }
    .order-detail{
      margin-top: 16px;
      .detail-list{
        line-height: 28px;
        margin-bottom: 32px;
        word-break: break-all;
        overflow: hidden;
        word-wrap: break-word;
      }
    }
  }
  .label {
    // width: 180px;
    margin-top: 0;
    font-size: 0;
    img{
      // width: 100%;
      height: 34px;
    }
    // display: flex;
    // flex-wrap: nowrap;
    // padding-top: 12px;
    // .label-item {
    //   display: flex;
    //   align-items: center;
    //   height: 30px;
    //   margin-right: 12px;
    //   margin-bottom: 12px;
    //   padding: 0 20px 0 16px;
    //   border-radius: 15px;
    //   font-size: 20px;
    //   color: #1174b8;
    //   background-color: #e8f4fe;
    //   .label-img {
    //     flex: none;
    //     width: 26px;
    //     margin-right: 6px;
    //   }
    // }
  }
}

.sell-out{
  display: flex;
  justify-content: flex-end;
  // margin-bottom: 6px;
}
.price-total-box {
  margin-top: 20px;
}
</style>
